import React, { useEffect } from 'react'
import { BackHandler } from 'react-native'

import { i18n } from '@localization'
import { publishEvent } from '@zet/analytics'
import { Icon } from '@zet/design-system/icons'
import { Stack } from '@zet/design-system/layout'
import Pressable from '@zet/design-system/pressable'
import Reward from '@zet/design-system/svg/Reward'
import { B1, H3, SH4 } from '@zet/design-system/typography'
import { ModalComponentProp } from 'react-native-modalfy'
import { SafeAreaView } from 'react-native-safe-area-context'

import ScratchCard from '@components/scratchCard'

import { useScratchCardReveal } from '../../api/rewards/hooks'
import { ModalStackParams } from '../modalConfig'

type Props = ModalComponentProp<ModalStackParams, void, 'ScratchCardModal'>

export default function ScratchCardModal({
  modal: { closeModal, getParam },
}: Props) {
  const scratchCardId = getParam('scratchCardId')
  const amount = getParam('amount')
  const isRecommendation = getParam('isRecommendation', false)
  const { mutate } = useScratchCardReveal()

  useEffect(() => {
    const backHandler = BackHandler.addEventListener(
      'hardwareBackPress',
      closeModal
    )
    return () => backHandler.remove()
  }, [])

  return (
    <>
      <SafeAreaView style={{ flex: 1 }}>
        <Pressable
          onPress={closeModal}
          className="mx-4 mt-6 self-end rounded bg-[#afb1b5]"
          eventName="close_button"
          eventPayload={{
            screen_name: isRecommendation
              ? 'scratch_card_new_card'
              : 'profile_scratch_card',
          }}
        >
          <Icon type="Close" color="white" />
        </Pressable>
        <Stack className="flex-1 justify-center self-center">
          <ScratchCard
            modalScreen={true}
            strokeWidth={40}
            width={155}
            height={155}
            maskImage={<Reward size={170} />}
            revealImagePath={
              amount == 0
                ? require('../../assets/images/revealEmptyImage.png')
                : require('../../assets/images/RevealReward.png')
            }
            revealImageDimensions={{
              width: '100%',
              height: '100%',
            }}
            revealText={
              amount == 0
                ? i18n.t('myRewards.betterLuck')
                : i18n.t('myRewards.youWon', { amount: amount })
            }
            onScratched={() => {
              mutate(scratchCardId)
              publishEvent('click_action', {
                item_name: isRecommendation
                  ? 'scratch_card_new_card_scratched'
                  : 'profile_scratch_card_new_card_scratched',
                amount: amount,
              })
            }}
          />
        </Stack>
        <Stack className="flex-2 ">
          <Stack className="   rounded bg-white p-4">
            <H3 className="">{i18n.t('myRewards.congratulations')}</H3>
            <B1 className="mt-2">{i18n.t('myRewards.youWonScratchCard')}</B1>
            <SH4 className="mt-2 bg-[#F5F7FB] pl-4">
              {i18n.t('myRewards.youCanSeeCards')}
            </SH4>
          </Stack>
        </Stack>
      </SafeAreaView>
    </>
  )
}
